import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api } from "../lib/api";
import { EMPLOYEE_STATUSES, getCustomStatuses, setCustomStatuses } from "../lib/constants";

const KINDS = [
  ["active", "نشط", "يُحسب راتبه ويظهر في الحضور والتنبيهات"],
  ["suspended", "متوقف", "مثل «موقوف»: لا يُسجَّل غائباً في الحضور"],
  ["ended", "منتهي", "مثل «منتهي الخدمة»: خارج الرواتب والتنبيهات والإحصاءات"],
];

export const EmpStatusManager = ({ open, onOpenChange, onSaved }) => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setRows(getCustomStatuses().map((r) => ({ ...r }))); }, [open]);
  const upd = (i, k, v) => setRows((p) => p.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const save = async () => {
    setBusy(true);
    try {
      const out = await api.setEmpStatuses(rows.filter((r) => r.name.trim()));
      setCustomStatuses(out); toast.success("تم حفظ الحالات"); onSaved?.(out); onOpenChange(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" dir="rtl" data-testid="emp-status-manager">
        <DialogHeader><DialogTitle>حالات الموظف</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">الأساسية: {EMPLOYEE_STATUSES.join("، ")}. أضف حالات خاصة بشركتك (مثل «هروب») وحدّد تأثيرها.</p>
        <div className="space-y-2">
          {rows.map((r, i) => (
            <div key={i} className="rounded-xl border border-slate-200 p-2.5" data-testid={`emp-status-row-${i}`}>
              <div className="flex gap-2">
                <Input value={r.name} onChange={(e) => upd(i, "name", e.target.value)} placeholder="اسم الحالة" className="h-9" data-testid={`emp-status-name-${i}`} />
                <Button variant="ghost" size="icon" className="h-9 w-9 shrink-0 text-rose-600" onClick={() => setRows((p) => p.filter((_, j) => j !== i))} data-testid={`emp-status-del-${i}`}><Trash2 className="h-4 w-4" /></Button>
              </div>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {KINDS.map(([k, l, hint]) => (
                  <button key={k} type="button" title={hint} onClick={() => upd(i, "kind", k)} data-testid={`emp-status-kind-${i}-${k}`}
                    className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${r.kind === k ? (k === "ended" ? "border-rose-600 bg-rose-600 text-white" : k === "suspended" ? "border-amber-500 bg-amber-500 text-white" : "border-emerald-600 bg-emerald-600 text-white") : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>{l}</button>
                ))}
              </div>
              <p className="mt-1 text-[11px] text-slate-400">{KINDS.find(([k]) => k === r.kind)?.[2]}</p>
            </div>
          ))}
          <Button variant="outline" className="w-full gap-1.5" onClick={() => setRows((p) => [...p, { name: "", kind: "ended" }])} data-testid="emp-status-add"><Plus className="h-4 w-4" /> إضافة حالة</Button>
        </div>
        <Button onClick={save} disabled={busy} className="w-full" data-testid="emp-status-save">{busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ</Button>
      </DialogContent>
    </Dialog>
  );
};
